import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=cbc16c36"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=cbc16c36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports